import React, { useCallback, useState } from 'react';
import AnnonceTiroir from './AnnonceTiroir';
import { ancre } from '../../tutoriel/ancres';

/**
 * Le bouton « Annonce » : dans l'en-tête d'un besoin (cible = ce besoin,
 * ancre du tutoriel `besoin-annonce`), ou dans la barre du Vivier (cible =
 * un vivier, ou un besoin choisi à la création).
 */
const BI = ({ icon }) => <i className={`bi bi-${icon}`} aria-hidden="true" />;

export default function BoutonAnnonce({ cible = 'besoin', besoin = null, showNotification, onVivierCree, className = 'bd-btn' }) {
  const [ouvert, setOuvert] = useState(false);
  const fermer = useCallback(() => setOuvert(false), []);
  if (cible === 'besoin' && !besoin?.id) return null;
  return (
    <>
      <button type="button" className={className} onClick={() => setOuvert(true)} {...(cible === 'besoin' ? ancre('besoin-annonce') : {})}>
        <BI icon="megaphone" /> {cible === 'besoin' ? 'Annonce' : 'Annonces'}
      </button>
      {ouvert && <AnnonceTiroir cible={cible} besoin={besoin} onClose={fermer} showNotification={showNotification} onVivierCree={onVivierCree} />}
    </>
  );
}
